import { Row } from "@/components/Row";

// Three dots taking turns, the way a phone shows someone typing.
export const SadieSimulatorTypingDots = () => (
  <Row className="h-6 items-center gap-1 self-start">
    {[0, 1, 2].map((i) => (
      <span
        className="h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400"
        key={i}
        style={{ animationDelay: `${String(i * 150)}ms` }}
      />
    ))}
  </Row>
);
